<template>
    <div>


        <div class="sifarnik-top-line">

            <div class="sifarnik-top-left">
                <RouteTab current_tab="Tarife" />
            </div>
            <CustomDropdown height="32rem" :id="'drop_head_filter'" v-model="selected_head" :drop_items="heads_filter"
                init_text="Glave tarife" />
            <div class="sifarnik-top-right">
                <div class=" sifarnik-search crm-search" v-if="false"><input type="text" placeholder="Pretraži šifrarnik..">
                    <div class="top-search-button"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26"
                            viewBox="0 0 26 26">
                            <g>
                                <g>
                                    <path fill="#fff"
                                        d="M25.714 25.714a.952.952 0 0 1-1.346 0l-6.295-6.295A10.95 10.95 0 0 1 11 21.999C4.925 22 0 17.076 0 11 0 4.926 4.925 0 11 0s11 4.926 11 11c0 2.696-.972 5.161-2.581 7.074l6.295 6.295a.952.952 0 0 1 0 1.346zM20 11a9 9 0 1 0-18 0 9 9 0 0 0 18 0z" />
                                </g>
                            </g>
                        </svg></div>
                </div>
                <div class="upload-stavke-button upload-dokumenta-button " @click="addNew(true)">
                    {{ $t("predlosci_page.tarife.new_tarifa") }}
                    <div class="upload-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                            <g>
                                <g>
                                    <path fill="#fff"
                                        d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" />
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="sifarnik-main-wrapper">
            <div class="sifarnik-item-wrapper">
                <custom-spinner v-if="fetching" />
                <SingleSifra v-else v-for="(single, key) in finall_arr_sifre" :key="key" :sifra="single" :depth="0"
                    @edit-single="editSingle" @add-parent="newFromParrent" @delete-single="deleteSingle" />
                <v-dialog v-model="popView" width="800px">
                    <v-card class="tarife-unos" color="universal-vcard">
                        <div class="universal-vdialog-title">
                            {{ $t("predlosci_page.tarife.tarifa_popup.new_popup_title") }}
                        </div>
                        <div class="sifra-form-wrapper">
                            <CustomMultiselect height="32rem" :id="'drop_reference_input'" :drop_items="mappedAllReff()"
                                :selected_items.sync="new_sifra.references"
                                :init_text="$t('predlosci_page.tarife.tarifa_popup.skupina')" />
                        </div>
                        <div class="sifra-form-wrapper">
                            <CustomDropdown height="32rem" :id="'drop_parents'" v-model="new_sifra.parrent_id"
                                :drop_items="mappedAll()" :init_text="$t('predlosci_page.tarife.tarifa_popup.skupina')" />
                            <v-text-field class="universal-vdialog-textfield number-field" type="text"
                                :label="$t('predlosci_page.tarife.tarifa_popup.tarif_number')"
                                placeholder="$t('predlosci_page.tarife.tarifa_popup.tarif_number')"
                                v-model="new_sifra.number">
                            </v-text-field>
                        </div>

                        <div class="sifra-form-wrapper">
                            <CustomDropdown v-if="new_sifra.parrent_id == null"  height="32rem" :id="'drop_head'" v-model="new_sifra.head_id"
                                :drop_items="heads_filter" init_text="Glave tarife" />
                        </div>
                        <div class="sifra-form-wrapper second-row">
                            <v-text-field class="universal-vdialog-textfield tabularni-name" type="text"
                                :placeholder="$t('predlosci_page.tarife.tarifa_popup.tarif_stavka_label')"
                                :label="$t('predlosci_page.tarife.tarifa_popup.tarif_stavka_label')"
                                v-model="new_sifra.name"></v-text-field>
                            <v-text-field class="universal-vdialog-textfield number-field" type="number"
                                :placeholder="$t('predlosci_page.tarife.tarifa_popup.points_number')"
                                :label="$t('predlosci_page.tarife.tarifa_popup.points_number')" v-model="new_sifra.value"
                                v-if="new_sifra.parrent_id != null"></v-text-field>
                        </div>
                        <div class="sifra-opis-wrapper">
                            <!-- <v-textarea class="universal-vdialog-textfield" type="text"
                                placeholder="Opis tarifne stavke" label="Opis tarifne stavke"
                                v-model="new_sifra.description"></v-textarea> -->
                            <span class="opis-stavke-title">{{ $t("predlosci_page.tarife.tarifa_popup.tarifa_descript")
                            }}</span>
                            <ckeditor :editor="editor" v-model="new_sifra.description" :config="editorConfig"></ckeditor>
                        </div>

                        <div class="vdialog-buttons-wrapper">
                            <div class="universal-vdialog-button vbutton-secondary" @click="clearNewEdit()">
                                {{ $t("repetitive.cancel") }}
                            </div>
                            <div class="universal-vdialog-button vbutton-primary" @click="addNewSifra()"> {{
                                $t("predlosci_page.tarife.tarifa_popup.pohrani") }}
                            </div>
                        </div>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="editingMode" width="800px">
                    <v-card class="tarife-unos" color="universal-vcard">
                        <div class="universal-vdialog-title">
                            Uređivanje tarifne stavke
                        </div>
                        <div class="sifra-form-wrapper">
                            <CustomMultiselect height="32rem" :id="'drop_reference'" :drop_items="mappedAllReff()"
                                :selected_items.sync="edit_sifra.references" init_text="Odaberite skupinu" />
                            <CustomDropdown v-if="edit_sifra.parrent_id == null" height="32rem" :id="'drop_head'" v-model="edit_sifra.head_id"
                                :drop_items="heads_filter" init_text="Glave tarife" />
                        </div>
                        <div class="sifra-form-wrapper">
                            <v-text-field class="universal-vdialog-textfield number-field text1" type="text"
                                :label="$t('predlosci_page.tarife.tarifa_popup.tarif_number')"
                                :placeholder="$t('predlosci_page.tarife.tarifa_popup.tarif_number')"
                                v-model="edit_sifra.number" readonly></v-text-field>
                            <v-text-field class="universal-vdialog-textfield text2" type="text"
                                :placeholder="$t('predlosci_page.tarife.tarifa_popup.tarif_stavka_label')"
                                :label="$t('predlosci_page.tarife.tarifa_popup.tarif_stavka_label')"
                                v-model="edit_sifra.name"></v-text-field>
                            <v-text-field class="universal-vdialog-textfield number-field text3" type="number"
                                :placeholder="$t('predlosci_page.tarife.tarifa_popup.points_number')"
                                :label="$t('predlosci_page.tarife.tarifa_popup.points_number')" v-model="edit_sifra.value"
                                v-if="edit_sifra.parrent_id != null"></v-text-field>
                        </div>

                        <div class="sifra-opis-wrapper">
                            <span class="opis-stavke-title">{{ $t("predlosci_page.tarife.tarifa_popup.tarifa_descript")
                            }}</span>
                            <ckeditor :editor="editor" v-model="edit_sifra.description" :config="editorConfig"></ckeditor>
                        </div>
                        <!-- <v-textarea class="universal-vdialog-textfield" type="text"
                                placeholder="Opis tarifne stavke" label="Opis tarifne stavke"
                                v-model="edit_sifra.description"></v-textarea> -->
                        <div class="vdialog-buttons-wrapper">
                            <div class="universal-vdialog-button vbutton-secondary" @click="clearNewEdit()">
                                {{ $t("repetitive.cancel") }}
                            </div>
                            <div class="universal-vdialog-button vbutton-primary" @click="editOld()"> {{
                                $t("predlosci_page.tarife.tarifa_popup.pohrani") }}
                            </div>
                        </div>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="delete_screen" width="564px">
                    <v-card color="universal-vcard">
                        <div class="universal-vdialog-title">
                            {{ $t("predlosci_page.tarife.tarifa_popup.delete_title") }} {{ delete_obj.name }}
                        </div>
                        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
                            <div class="universal-vdialog-button vbutton-secondary" @click="delete_screen = false">
                                {{ $t("repetitive.cancel") }} </div>
                            <div class="universal-vdialog-button vbutton-primary" @click="finishDelete()">
                                {{ $t("predlosci_page.tarife.tarifa_popup.delete") }} </div>
                        </div>
                    </v-card>
                </v-dialog>
            </div>
        </div>

    </div>
</template>

<script>
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import CustomMultiselect from "@/components/generalComponents/CustomMultiselect.vue";
import SingleSifra from "@/components/costSheetComponents/sifarnik/SingleSifra.vue";
import RouteTab from "@/components/costSheetComponents/sifarnik/RouteTab.vue";
import sifra_handler from "@/apiCallers/promise_handler_db/sifarnik.js"
import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@/plugins/ckeditor_build';
import gsap from 'gsap';
import CustomSpinner from "@/components/generalComponents/CustomSpinner.vue";

export default {
    components: {
        CustomDropdown,
        CustomMultiselect,
        SingleSifra,
        RouteTab,
        ckeditor: CKEditor.component,
        CustomSpinner
    },
    data() {
        return {
            editor: ClassicEditor,
            editorData: '<p></p>',
            editorConfig: {
                toolbar: {
                    items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'link',
                        '|',
                        'undo',
                        'redo',
                        '|',
                        'bulletedList',
                        'numberedList',
                        'texttransform'
                    ]
                },
                link: {
                    // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
                    addTargetToExternalLinks: true,
                }
            },
            edit_sifra: {
                uid: "",
                name: "",
                number: "",
                description: "",
                parrent_id: null,
                references: [],
                value: 0,
                other_sifarnik: [],
                head_id: null
            },
            editingMode: false,

            delete_screen: false,
            delete_obj: {
                uid: "",
                name: "",
                description: "",
                number: "",
                parrent_id: null,
                references: null,
                value: 0,
                other_sifarnik: [],
                head_id: null
            },

            // data for recursion test
            popView: false,
            new_sifra: {
                uid: "",
                description: "",
                name: "",
                number: "",
                parrent_id: null,
                references: [],
                value: 0,
                head_id: null
            },
            sifra_arr: [],
            selected_type: null,
            single_row_sifra: [],
            heads_sifre: [],
            heads_filter: [],
            selected_head: null,
            all_refferences: [],
            fetching: true,
        };

    },
    async created() {
        await sifra_handler.getAllSifra().then((resp) => {
            let simplified_resp = resp.data.all_sifra
            this.heads_sifre = resp.data.heads_sifre
            this.heads_filter = resp.data.heads_filter
            console.log(this.heads_sifre)
            this.single_row_sifra = resp.data.all_sifra
            let main_list = simplified_resp.filter((p) => p.parrent_id == null);
            main_list.forEach((p) => {
                p["children"] = this.getAllChildren(simplified_resp, p.uid)
            })
            this.sifra_arr = (main_list)


        }).finally(() => {
            this.fetching = false;
        })
    },
    computed:{
        finall_arr_sifre: function(){
            if(this.selected_head == null )
            {
                return this.sifra_arr
            }else return this.sifra_arr.filter((p) => p.head_id == this.selected_head)
        }
    },
    watch: {
        selected_type: function () {
            console.log(this.selected_type);
        },
        "new_sifra.parrent_id": function () {
            this.resetNumber();
        }
    },

    methods: {
        getAllChildren: function (simplified_resp, uid) {
            let main_list = simplified_resp.filter((p) => p.parrent_id == uid);
            main_list.sort((a, b) => {
                const num_arr_a = a.number.split('.');
                const num_arr_b = b.number.split('.');
                return num_arr_a[num_arr_a.length - 1] - num_arr_b[num_arr_b.length - 1];
            })
            main_list.forEach((p) => {
                p["children"] = this.getAllChildren(simplified_resp, p.uid)
            })
            return main_list;
        },
        addNew: function (condt) {
            if (condt) {
                this.resetValues()
                this.new_sifra.number = this.sifra_arr.length + 1;
                this.new_sifra.name = "Tbr. " + this.new_sifra.number;
            }
            this.editingMode = false;
            this.popView = true;
            setTimeout(() => {
                gsap.to('.sifra-opis-wrapper', 1, { width: '99%' })
                gsap.to('.sifra-opis-wrapper', 1, { width: '100%' })
            }, 100);

        },
        clearNewEdit: function () {
            this.editingMode = false;
            this.popView = false;
        },
        resetValues() {
            this.new_sifra =
            {
                name: "",
                number: "",
                parrent_id: null,
                value: 0,
                references: []
            }
        },
        resetNumber: function () {
            if (this.new_sifra.parrent_id != null) {
                let tmp_parent = this.single_row_sifra.find((p) => p.uid == this.new_sifra.parrent_id)
                this.new_sifra.number = tmp_parent.number.split(".").length >= 2 ? tmp_parent.number : tmp_parent.number + "." + parseInt(tmp_parent.children.length + 1);
                this.new_sifra.name = "";

            } else {
                this.new_sifra.number = this.sifra_arr.length + 1;
                this.new_sifra.name = "";
                this.new_sifra.head_id = null;
            }

        },
        newFromParrent: function (uid) {
            this.resetValues()
            this.new_sifra.parrent_id = uid;
            this.addNew(false);
            this.resetNumber()

        },
        editSingle: function (node) {
            this.edit_sifra = {
                uid: node.uid,
                name: node.name,
                number: node.number,
                parrent_id: node.parrent_id,
                value: node.value,
                other_sifarnik: node.children,
                description: node.description == undefined || node.description == null ? '' : node.description,
                //references makni iz [] kad iz backa dobimo listu referenci
                references: node.references,
                head_id : node.head_id
            },
                this.editingMode = true;
            setTimeout(() => {
                gsap.to('.sifra-opis-wrapper', 1, { width: '99%' })
                gsap.to('.sifra-opis-wrapper', 1, { width: '100%' })
            }, 100);
        },
        addNewSifra: async function () {
            console.log(this.new_sifra);
            await sifra_handler.addNewSifra(this.new_sifra).then((resp) => {
                this.editingMode = false;
                this.popView = false;
                let simplified_resp = resp.data
                this.single_row_sifra = resp.data
                let main_list = simplified_resp.filter((p) => p.parrent_id == null);
                main_list.forEach((p) => {
                    p["children"] = this.getAllChildren(simplified_resp, p.uid)
                })
                this.sifra_arr = (main_list)
                this.resetValues()
            })

        },
        editOld: async function () {
            await sifra_handler.editSifra(this.edit_sifra).then((resp) => {
                this.editingMode = false;
                this.popView = false;
                let simplified_resp = resp.data
                this.single_row_sifra = resp.data
                let main_list = simplified_resp.filter((p) => p.parrent_id == null);
                main_list.forEach((p) => {
                    p["children"] = this.getAllChildren(simplified_resp, p.uid)
                })
                this.sifra_arr = (main_list)
                this.resetValues()
            })
        },
        deleteSingle: async function (node) {
            console.log(node)
            this.delete_obj = node;
            this.delete_screen = true;
        },
        finishDelete: async function () {
            await sifra_handler.deleteSifra(this.delete_obj.uid).then((resp) => {
                this.delete_screen = false;
                let simplified_resp = resp.data
                this.single_row_sifra = resp.data
                let main_list = simplified_resp.filter((p) => p.parrent_id == null);
                main_list.forEach((p) => {
                    p["children"] = this.getAllChildren(simplified_resp, p.uid)
                })
                this.sifra_arr = (main_list)

            })
        },
        mappedAll: function () {
            let temp_arr = [{
                id: null,
                naziv: this.$t("predlosci_page.tarife.choose_parent")
            }]
            temp_arr = temp_arr.concat
                (this.single_row_sifra.map((p) => ({
                    id: p.uid,
                    naziv: !p.name.toLowerCase().startsWith('tbr.') ? `Tbr. ${p.number} ${p.name}` : p.name,
                })))
            return temp_arr;
        },
        mappedAllReff: function () {
            let temp_arr = [{
                id: null,
                naziv: this.$t("predlosci_page.tarife.no_refs")
            }]
            temp_arr = temp_arr.concat
                (this.single_row_sifra.map((p) => ({
                    id: p.uid,
                    naziv: !p.name.toLowerCase().startsWith('tbr.') ? `Tbr. ${p.number} ${p.name}` : p.name,
                    number: p.number,
                })))
            return temp_arr;
        }
    },

    mounted() {

        this.$store.state.paginacija.title = this.$t("breadcrumbs.sifrarnici");
    }

}

</script>

<style></style>